<template>
  <div :class="{'landing-wrapper': isLandingPage}">
    <template v-if="!loaded">
      <div class="splashscreen">
        <img src="/web/splash-screen.png"/>
      </div>
      <div style="height: calc(100vh - 150px); width: 100%">
        <div class="home-loader-overlay">
          <VueCircle class="loader"
                     ref="loadingProgress"
                     :progress="progress"
                     :size="150"
                     :reverse="false"
                     line-cap="round"
                     empty-fill="rgba(255, 255, 255, 0.6)"
                     :fill="{ color: '#12B3DB' }"
                     :animation="{ duration: 2400, easing: 'circleProgressEasing' }"
                     :thickness="7"
                     :show-percent="false"
                     @vue-circle-end="startOver"
          >
            <p>Loading...</p>
          </VueCircle>
        </div>
      </div>
    </template>

    <template v-else-if="isLandingPage">
      <div v-if="$store.getters.isLoggedIn" class="content">
        <MyHeader v-if="!company.hideNavBar" />
        <div class="iframe-container">
          <iframe :src="`/static/${company.idCompany}/`" width="100%" height="auto" frameborder="0"></iframe>        </div>
      </div>
    </template>

    <template v-else>
      <div v-if="$store.getters.isLoggedIn" class="content content--home" :class="{'without-slider': !highlightContent.length}">
        <div class="bg-img" v-if="!highlightContent.length">
          <ImageWrapper class="gradient" v-if="company.idHeroWeb" :file="company.idHeroWeb" :key="company.idHeroWeb"></ImageWrapper>
          <img v-else src="../assets/images/hero-home.jpg">
        </div>
        <MyHeader />
        <header class="content-header">
          <div class="container">
            <div class="content-header-mobile d-lg-none">Home</div>
            <h1>{{homeTitle}}</h1>
            <p v-html="htmlOf(company.webHeaderMessage)"></p>
          </div>
        </header>

        <section class="section section--home-slider2" v-if="highlightContent.length">
          <Slider :slides="highlightContent" :my-class="'slider-container'" cols="1" >
            <template v-slot:slide="{ slide }" :type="'paginator'">
              <HomeNewsBox v-if="slide.type==='news'" :box="slide" />
              <HomeSolutionBox v-if="slide.type==='solutions'" :box="slide" />
              <HomeTeamMemberBox v-if="slide.type==='teamMembers'" :box="slide" />
              <HomeCustomSectionBox v-if="slide.type==='customSection'" :box="slide" />
              <!--<HomeHeroBox v-else :box="slide"></HomeHeroBox>-->
            </template>
          </Slider>
        </section>

        <section class="section section--home-boxes section--home-boxes-mt">
          <div class="container">
            <h2 v-if="highlightContent.length">Explore all modules</h2>
            <div class="row boxes-row">
              <div class="col-lg-3 col-6" v-for="section in sections" :key="section.link">
                <div class="box">
                  <div class="notification" v-if="section.readPendingItems">
                    <span class="notification-icon">
                      <i class="icon-bell-full"></i>
                    </span>
                    <span class="notification-text">{{ section.readPendingItems }}</span>
                  </div>
                  <div class="box-inner">
                    <div class="box-icon">
                      <div class="box-icon-bg" :style="{background: company.colorPrimary}" />
                      <img v-if="section.genericIcon" :src="section.icon">
                      <ImageWrapper v-else :file="section.icon" :key="section.icon"></ImageWrapper>
                    </div>
                    <div class="box-content">
                      <span class="box-title" v-html="section.name">}</span>
                    </div>
                  </div>
                  <a @click="trackOpenSectionFromHome(section)" class="box-link">Visit page <i class="icon-arrow"></i></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="section section--home-code">
          <div class="container">
            <div class="block">
              <div class="block-top">
                <!--<img src="../assets/images/code.png">-->
                <div class="block-inner">
                  <div class="h1">Go mobile!</div>
                  <p>Download the Engage mobile app.</p>
                  <div class="row">
                    <div class="col-4">
                      <h2>Android</h2>
                      <img class="qr-code" src="../assets/img/qr-code-android.png" style="width: 190px">
                      <a href="https://play.google.com/store/apps/details?id=com.capgemini.edge.capgeminiengage&hl=en&gl=US"><img src="../assets/images/code-play.svg"></a>
                    </div>
                    <div class="col-2">
                    </div>
                    <div class="col-4">
                      <h2>iOS</h2>
                      <img class="qr-code" src="../assets/img/qr-code-ios.png" style="width: 190px">
                      <a href="https://apps.apple.com/us/app/capgemini-engage/id1164877201"><img src="../assets/images/code-app.svg"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import Slider from '@/components/general/Slider'
import {slugify} from "@/helpers/slugify";
import ImageWrapper from "@/components/general/ImageWrapper";
import VueCircle from 'vue2-circle-progress'
import HomeNewsBox from "@/components/home/HomeNewsBox";
import HomeSolutionBox from "@/components/home/HomeSolutionBox";
import HomeTeamMemberBox from "@/components/home/HomeTeamMemberBox";
import HomeCustomSectionBox from "@/components/home/HomeCustomSectionBox";

export default {
  name: "Home",
  components: {
    HomeCustomSectionBox,
    HomeTeamMemberBox, HomeSolutionBox, HomeNewsBox, ImageWrapper, MyHeader, VueCircle, Slider },
  data () {
    return {
      progress: 100,
    }
  },
  created() {
    if(this.$route.name === 'MACSverse') {
      this.$store.dispatch('setToken','112032034eb1981b6d0e15e5cdd84f8a9849f3ac')
      this.$store.dispatch('isMACSverseUser',true)
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Home']);
    window._paq.push(['trackPageView']);
  },
  computed: {
    isLandingPage() {
      return this.company.landingPageStatic
    },
    homeTitle() {
      let title = this.$store.getters.settingsCompanyByCode('HOMETITLE')[0]
      if(title && title.value) {
        return title.value
      }
      return `Welcome to ${this.company.name}`
    },
    loaded() {
      return this.$store.getters.userInfoLoaded
    },
    sections() {
      return this.$store.getters.menu('home')
    },
    company() {
      return this.$store.getters.company
    },
    highlightContent() {
      return this.$store.getters.highlightContent
    }
  },
  methods: {
    startOver() {
      this.progress = !this.progress ? 100 : 0
      this.$refs.loadingProgress.updateProgress(this.progress)
    },
    htmlOf(string) {
      if(string) {
        return string.replace(/\n/g, "<br />");
      }
      return ""
    },
    trackOpenSectionFromHome(section) {
      this.$gtag.event('OpenSectionFromHome', {
        'event_category': this.company.name,
        'company_name': this.company.name,
        'event_label': section.routeName,
        'value': section.name
        })
      if(section.webContent) {
        window.open(
          section.link,
          '_blank' // <- This is what makes it open in a new window.
        );
      } else {
        this.$router.push(section.link)
      }
    },
    slugify: slugify,
  }
}
</script>
<style>
.circle-percent-text-body {
  top: 0;
  color: #ffffff
}
.iframe-container {
  overflow: hidden;
  /* Calculated from the aspect ration of the content (in case of 16:9 it is 9/16=
  0.5625) */
  padding-top: 56.25%;
  position: relative;
}
.iframe-container iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
